// extracted by mini-css-extract-plugin
export default {"root":"ToggleSwitch_root__G8uod","switch":"ToggleSwitch_switch__QjFCG","slider":"ToggleSwitch_slider__VC+dA","round":"ToggleSwitch_round__bKXq-"};